import { IUpdatePesquisaSatisfacaoItemUseCase } from "../../../presentation/useCases/update/update_pesquisa_satisfacao_item_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * UpdatePesquisaSatisfacaoItemUseCase
 */

export class UpdatePesquisaSatisfacaoItemUseCase implements IUpdatePesquisaSatisfacaoItemUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async updatePesquisaSatisfacaoItem(
    idItemPesquisaSatisfacao: number,
    ordem: string,
    descricao: string,
  ): Promise<void> {
    await this.repository.updatePesquisaSatisfacaoItem(
      idItemPesquisaSatisfacao,
      ordem,
      descricao,
    );
  }
}
